import { render, staticRenderFns } from "./DormitoryList.vue?vue&type=template&id=6d4168f4&scoped=true&"
import script from "./DormitoryList.vue?vue&type=script&lang=js&"
export * from "./DormitoryList.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryList.vue?vue&type=style&index=0&id=6d4168f4&prod&lang=scss&scoped=true&"
import style1 from "./DormitoryList.vue?vue&type=style&index=1&id=6d4168f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4168f4",
  null
  
)

export default component.exports